var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62 45.2a7.2 7.2 0 0 0 6.77-9.655l-7.425 7.425-4.775-4.776 1.697-1.697 3.078 3.079 6.186-6.186A7.2 7.2 0 1 0 62 45.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M48 33.712H12v12.576h36zm-38-2v16.576h40V31.712z",
    clipRule: "evenodd"
  })));
};
export default SvgQuestion;